import { ApartmentsContainer } from '../../containers/advancedFilters/ApartmentsContainer';
import { IFilter } from '../../types/advancedFilters';

export const apartments: IFilter = {
  component: ApartmentsContainer,
};
